"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
require("antd/lib/button/style");
var _button = _interopRequireDefault(require("antd/lib/button"));
var _react = _interopRequireDefault(require("react"));
var _lodash = require("lodash");
var _RangeFilter = _interopRequireDefault(require("../RangeFilter"));
var _utils = require("../../../utils");
function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
var config = function config(dataSource, onSeeDetails) {
  var statusFilters = (0, _lodash.uniq)(dataSource.map(function (r) {
    return r.status;
  })).map(function (s) {
    return {
      text: s,
      value: s
    };
  });
  var columns = [{
    title: 'Type',
    dataIndex: 'type',
    key: 'type',
    render: function render(id, _ref) {
      var invoice = _ref.invoice;
      return invoice.metadata.paymentType ? invoice.metadata.paymentType.toUpperCase() : 'SUBSCRIPTION';
    },
    width: '140px'
  }, {
    title: 'Date and time',
    dataIndex: 'created',
    key: 'created',
    filterDropdown: function filterDropdown(props) {
      return /*#__PURE__*/_react.default.createElement(_RangeFilter.default, props);
    },
    onFilter: (0, _utils.dateRangeFilter)('created'),
    render: function render(id, record) {
      return (0, _utils.formatDate)(record.created, {
        withTime: true
      });
    },
    sorter: (0, _utils.timeSorter)('created'),
    width: '220px'
  }, {
    title: 'Amount',
    dataIndex: 'amount',
    key: 'amount',
    render: function render(id, record) {
      return "USD ".concat(record.amount);
    },
    sorter: (0, _utils.digitSorter)('amount'),
    width: '110px'
  }, {
    title: 'Next Payment Attempt',
    dataIndex: 'nextPaymentAttempt',
    key: 'nextPaymentAttempt',
    render: function render(id, _ref2) {
      var invoice = _ref2.invoice;
      return (0, _utils.formatDate)(invoice.nextPaymentAttempt);
    },
    sorter: (0, _utils.digitSorter)('amount'),
    width: '140px'
  }, {
    title: 'Status',
    dataIndex: 'status',
    key: 'status',
    filters: statusFilters,
    onFilter: (0, _utils.filter)('status'),
    sorter: (0, _utils.stringSorter)('status'),
    width: '110px'
  }, {
    title: 'Actions',
    dataIndex: 'actions',
    key: 'actions',
    render: function render(text, record) {
      return /*#__PURE__*/_react.default.createElement(_button.default, {
        type: "link",
        className: "btn-link blue-btn-link",
        onClick: function onClick() {
          return onSeeDetails && onSeeDetails(record);
        }
      }, "See details");
    },
    width: '300px'
  }];
  return {
    columns: columns,
    dataSource: dataSource,
    rowKey: 'id'
  };
};
var _default = config;
exports.default = _default;